

    
        jQuery(function() {
  try {
    var $module = jQuery('#m-1594396448639').children('.module');   
    var navspeed = $module.data('navspeed'),
      autoplaytimeout = $module.data('autoplaytimeout'),
      autoplayhoverpause = $module.data('autoplayhoverpause'),
      navlg = $module.data('navlg'),
      navmd = $module.data('navmd'),
      navsm = $module.data('navsm'),
      navxs = $module.data('navxs'),
      collg = $module.data('collg'),
      colmd = $module.data('colmd'),
      colsm = $module.data('colsm'),
      colxs = $module.data('colxs'),
      dotslg = $module.data('dotslg'),
      dotsmd = $module.data('dotsmd'),
      dotssm = $module.data('dotssm'),
      dotsxs = $module.data('dotsxs'),
      marginlg = parseInt($module.data('marginlg')),
      marginmd = parseInt($module.data('marginmd')),
      marginsm = parseInt($module.data('marginsm')),
      marginxs = parseInt($module.data('marginxs'));

    var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
    if(mode == 'production') {
      var autoplay = $module.data('autoplay'), 
          loop = $module.data('loop');
    } else {
      var autoplay = 0, 
          loop = 0;
    }

    var initCarousel = function() {
      $module.owlCarousel({
        mouseDrag: false,
        autoplayHoverPause: autoplayhoverpause,
        autoplay: autoplay,
        autoplayTimeout: autoplaytimeout,
        loop: loop,
        navSpeed: navspeed,
        autoWidth: !1,
        responsiveClass:true,
        responsive:{
          0:{
              items:colxs,
              nav: navxs,
              dots:dotsxs,
              margin: marginxs
          },
          768:{
              items:colsm,
              nav: navsm,
              dots:dotssm,
              margin: marginsm
          },
          992:{
              items:colmd,
              nav: navmd,
              dots:dotsmd,
              margin: marginmd
          },
          1200:{
              items:collg,
              nav: navlg,
              dots:dotslg,
              margin: marginlg
          }
        }
      });
    }
    
    // Fix nested carousel bug	
    if ($module.parent().parent().closest('.module-wrap[data-label="Carousel"]').length > 0) {	
        setTimeout(function() {	
            initCarousel();	
        }, 300)	
    } else {	
        initCarousel();	
    }
  } catch(err) {}
}); 
    
        jQuery(function() {
  var $module = jQuery('#m-1594395820170').children('.module');
  $module.gfV3Product();
}); 
    
    
        jQuery(function() {
    var $module = jQuery('#m-1594395821773').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
    
        jQuery(function() {
  var $module = jQuery('#m-1594395821416').children('.module');
  $module.gfV3ProductImageList({
      onImageClicked: function(imageUrl, imageZoomUrl) {}
  });

  var style = $module.attr('data-style');
  switch(style) {
      case 'slider':
          var navspeed = $module.data('navspeed'),
              navlg = $module.data('navlg'),
              navmd = $module.data('navmd'),
              navsm = $module.data('navsm'),
              navxs = $module.data('navxs'),
              collg = $module.data('collg'),
              colmd = $module.data('colmd'),
              colsm = $module.data('colsm'),
              colxs = $module.data('colxs'),
              dotslg = $module.data('dotslg'),
              dotsmd = $module.data('dotsmd'),
              dotssm = $module.data('dotssm'),
              dotsxs = $module.data('dotsxs'),

              marginlg = parseInt($module.data('mlg')),
              marginmd = parseInt($module.data('mmd')),
              marginsm = parseInt($module.data('msm')),
              marginxs = parseInt($module.data('mxs'));

          var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
          if(mode == 'production') {
              var loop = $module.data('loop');
          } else {
              var loop = 0;
          }
          $module.find('.gf_product-images-list').owlCarousel({
              mouseDrag: false,
              navSpeed: navspeed,
              autoWidth: !1,
              loop: loop,
              responsiveClass:true,
              responsive:{
                  0:{
                      items:colxs,
                      nav: navxs,
                      dots:dotsxs,
                      margin: marginxs
                  },
                  768:{
                      items:colsm,
                      nav: navsm,
                      dots:dotssm,
                      margin: marginsm
                  },
                  992:{
                      items:colmd,
                      nav: navmd,
                      dots:dotsmd,
                      margin: marginmd
                  },
                  1200:{
                      items:collg,
                      nav: navlg,
                      dots:dotslg,
                      margin: marginlg
                  }
              }
          }); 
          break;
  }
}); 
    
        jQuery(function() {
  var $module = jQuery('#m-1594395821064').children('.module');
});
    
        jQuery(function() {
        var $module = jQuery('#m-1594395821008').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
    
        jQuery(function() {
    var $module = jQuery('#m-1594395821002').children('.module');
    var swatchText = $module.attr('data-swatch-text') != undefined ? $module.attr('data-swatch-text') : '1';
    $module.gfV3ProductSwatches({
        swatchText: swatchText,
        onSwatchSelected: function(variant, $swatch) {}
    });
});
    
        jQuery(function() {
    var $module = jQuery('#m-1594395820625').children('.module');
    var style = $module.attr('data-style');
    var updatePrice = $module.attr('data-updateprice');

    $module.gfV3ProductQuantity({
        'style': style,
        'updatePrice': updatePrice
    });
});
    
        jQuery(function() {
  var $module = jQuery('#m-1594395820295').children('.module');
  $module.gfV3ProductCartButton({ onItemAdded: function(data) {}});
}); 
    
        jQuery(function() {
            var $module = jQuery('#m-1570089474822').children('.module');

            var limit = parseInt($module.attr('data-limit'));
            if($module.find('.gf_row.gf_row_no_tools .gf_column').length > limit) {
                $module.find('.gf_row.gf_row_no_tools .gf_column:last').hide();
            }
        }); 
    
    
        jQuery(function() {
            var $module = jQuery('#m-1570089474747');
            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            $module.css({
                'height': 'auto'
            });
            jQuery(window).resize(function(){
                $module.css('height', 'auto');
            });
            $module.children('.module').removeClass('full-height');

            var image = $module.children('.module').data('image') || '';
            if ($module.children('.module').data('speed') || $module.children('.module').data('speed') == 0) {
                var speed = parseFloat($module.children('.module').data('speed'));
            } else {
                var speed = 0.2;
            }
            if($module.data('gfv3parallax') != undefined) {
                $module.removeData('gfv3parallax');
            }
            $module.gfV3Parallax({
                'image': image,
                'speed': speed,
                'mode': mode
            });
            if(mode == 'dev') {
                var moduleId = "1570089474747";
                var moduleIdSlug = moduleId.toString().replace(/-/g, '');
                if (moduleIdSlug == "1570089474747") {
                    window.getParallax1570089474747 = function() {
                        return $module.data('gfv3parallax');
                    }
                }
            }
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1570089474770').children('.module');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'production') { 
                $module.find('button[type="submit"]').on('mouseover', function() {
                    try {
                        localStorage.setItem('gemId', '#m-1570089474770');
                    } catch(err) {}
                });

                var gemId = '';
                try {
                    var gemId = localStorage.getItem('gemId');
                } catch(err) {}

                if(gemId != '') {
                    var moduleId = '#' + $module.parent().attr('id');
                    if(gemId == moduleId) {
                        var cbLink = $module.find('input[name="gemcallback"]').val() != undefined ? jQuery.trim($module.find('input[name="gemcallback"]').val()) : '';

                        if(cbLink && cbLink != '') {
                            try {
                                localStorage.setItem('gemId', 'redirected');
                            } catch(err) {}

                            window.location.href = cbLink;
                        }
                    }
                } else {
                    var cbLink = $module.find('input[name="gemcallback"]').val() != undefined ? jQuery.trim($module.find('input[name="gemcallback"]').val()) : '';

                    if(cbLink && cbLink != '') {
                        window.location.href = cbLink;
                    }
                }
            } 
        });
    
var gemFlag=!1;for(var i=0;i<pageLibs.length;i++){if(pageLibs[i].indexOf('gfv3product.js')!==-1){if(jQuery.gfV3Product==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfv3restabs.js')!==-1){if(jQuery.gfV3ResTabs==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfaccordion.js')!==-1){if(jQuery.gfAccordion==undefined){gemFlag=!0;break}}}if(gemFlag){var count=0;for(var i=0;i<pageLibs.length-1;i++){jQuery.getScript(pageLibs[i],function(){count++;if(count==pageLibs.length-1){jQuery.getScript(pageLibs[pageLibs.length-1],function(){})}})}}